export default [
  {
    path: '/retargeting-attribution',
    name: 'PageRetargetingAttributionList',
    meta: { title: 'retargetingAttribution.report.listTitle', roles: ['ADMIN'], permissions: ['retargeting_attribution_view'] },
    component: () => import('@/pages/retargeting-attribution'),
  },
]
